//
export const LOGIN_USER = "login_user";
export const LOGGED_IN_USER = "LOGGED_IN_USER";
export const LOGGED_OUT_USER = "LOGGED_OUT_USER";
export const GLOGIN_USER = "glogin_user";
export const FLOGIN_USER = "flogin_user";
export const REGISTER_USER = "register_user";
export const AUTH_USER = "auth_user";
export const LOGOUT_USER = "logout_user";
export const ADD_TO_CART_USER = "add_to_cart_user";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const GET_CART_ITEMS_USER = "get_cart_items_user";
export const REMOVE_CART_ITEM_USER = "remove_cart_item_user";
export const ON_SUCCESS_BUY_USER = "on_success_buy_user";
export const POST_CITY = "POST_CITY";
export const SEARCH_QUERY = "SEARCH_QUERY";
export const SEARCH_BY_SLUG = "SEARCH_BY_SLUG";
export const SHOW_BY_H_CONDITION = "SHOW_BY_H_CONDITION";
